export default function Go_Data_Types () {
  return (
    <div>
      <h1>Go_Data_Types </h1>
      <p>Basic Data Types</p>
    </div>
  );
}